import { FC } from 'react';
import styled from 'styled-components';

import Loader from '.';

const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) =>
    `${theme.colors.black}${theme.opacity[50]}`};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

type Props = {
  isLoading: boolean;
};

const FullScreenLoader: FC<Props> = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <BackgroundOverlay>
      <Loader size={'xl'} />
    </BackgroundOverlay>
  );
};

export default FullScreenLoader;
